import {toThousands} from '../../util/util'
import httpManager from "../../util/common";
export default {
  data () {
    return {
      product_name: '',
      aum_report_date: '',
      aum_last_report_date: '',
      upload_title: 'SFDR Principal Adverse Impact Reporting Tool',
      selections: null,
      report_date: '',
      last_report_date: '',
      filterdata: '',
      upload_format: '/sfdrdownload/SFDR_Principle_Adverse_Impact_Report_Sample.xlsx' ,
      upload_format_name: 'SFDR_Principle_Adverse_Impact_Report_Sample.xlsx',
      loading: false,
      upload_file: null,
      formData: null,
    }
  },
  methods: {
    getFormData () {
      let self = this
      self.loading = true
      let data = new FormData() // FormData 对象
      data.append('file', this.upload_file) // 文件对象
      httpManager('sfdr_upload', null, data)
        .then(response => {
          self.selections = response.data.data
          window.sessionStorage.setItem('sfdr', JSON.stringify(self.selections))
          self.loading = false
        })
        .catch(error => {
          console.log(error)
          self.loading = false
        })
    },
    // 上传本地文件
    clickLoad () {
      this.$refs.refFile.click()
    },
    fileLoad (e) {
      this.upload_file = this.$refs.refFile.files[0]
      this.getFormData()
      e.target.value = ''
    },
    // 切换组件
    changeComponent () {
      if (!this.selections||this.selections.length === 0) alert('请先上传文件')
      else this.$router.push('/sfdrreport')
    },
    // vxe-table事件
    sortChangeEvent ({ sortList }) {
      sortList.map((item) => `${item.property},${item.order}`).join('; ')
    },


    formatDate (d) {
      if(d){
        let mydate = new Date(d)
        let year = mydate.getFullYear()
        let mounth = mydate.getMonth()+1
        let day = mydate.getDay()
        return year + "-" +mounth +"-" +day
      }
      return ' '
    },
    // 通过ticker筛选
    filterTableData(){
      if (this.filterdata=='') this.formData = JSON.parse(this.selections.uploaddata)
      else {
        var arr = []
        for(let i = 0; i < this.formData.length; i++){
          if(this.formData[i].Ticker.split(this.filterdata).length > 1){
            let obj = {}
            for(let attr in this.formData[i]){
              obj[attr] = this.formData[i][attr]
            }
            arr.push(obj)
          }
        }
        this.formData = arr
      }
    },
    fixNum(num) {
      if (!num) return ''
      let temp = num.toFixed(2)
      let b = temp.toString().split('.')
      num = toThousands(b[0]) + '.' + toThousands(b[1])
      return num
    }
  },
  created () {
    this.selections = JSON.parse(window.sessionStorage.getItem('sfdr'))
    if (this.selections) {
      if (this.selections.uploaddata) this.formData = JSON.parse(this.selections.uploaddata)
    }
  },
  watch: {
    selections: function () {
      this.formData = JSON.parse(this.selections.uploaddata)
      this.upload_title = this.selections?'SFDR Principal Adverse Impact Report of ' + this.selections.product_name : 'SFDR Principal Adverse Impact Reporting Tool'
      this.report_date = this.selections.report_date
      this.last_report_date = this.selections.last_report_date
      this.aum_report_date = this.selections.aum_reporting_date_currency + ' ' + this.fixNum(this.selections.aum_reporting_date)
      this.aum_last_report_date = this.selections.aum_last_reporting_date_currency + ' ' + this.fixNum(this.selections.aum_last_reporting_date)
    }
  },
  computed: {
    tableColumn() {
      return [
        {title: 'ID', type: 'seq', width: 60},
        {title: this.$t('common.report_date'), field: 'report_date', sortable: true},
        {title: this.$t('common.ticker'), field: 'Ticker', sortable: true},
        {title: 'ISIN', field: 'ISIN', sortable: true},
        {title: this.$t('common.company_short_name'), field: 'short_name', sortable: true, width: 250},
        {title: this.$t('common.industry'), field: 'gics', sortable: true},
        {title: this.$t('sfdr.weight'),
          field: 'Weight(%)',
          sortable: true,
          formatter: ({cellValue})=>{
            return cellValue?(cellValue).toFixed(2) + '%':""
          }
        },
        {title: this.$t('sfdr.enterprise_value'),
          field: 'enterprise_value',
          sortable: true,
          formatter: ({cellValue})=>{
            var b = cellValue?cellValue.toString().split('.'):["",""]
            return toThousands(b[0]) + '.' + toThousands(b[1])
          }
        },
        {title: this.$t('common.currency'), field: 'enterprise_value_currency'},
        {title: this.$t('sfdr.covered_in_report'), field: 'covered_in_report', width: 180}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/sfdr/js/sfdr_upload.js